import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div>
            <main className="text-center min-h-[50vh]">
              <p className="text-center text-red font-bold text-6xl">404!</p>
              <button className="bg-green text-white px-4 py-2 rounded-md	">
                <Link to="/">Back to Home</Link>
              </button>
            </main>
        </div>
    );
};

export default NotFound;